import OpenNewIcon from './OpenNew'
import StarActiveIcon from './StarActive'
import StarInactiveIcon from './StarInactive'
import EditSurveyIcon from './EditSurvey'
import RemoveResponseIcon from './RemoveResponse'
import AddIcon from './Add.vue'
import ErrorIcon from './ErrorIcon'
import UpArrowIcon from './UpArrow.vue'

export default {
    OpenNewIcon,
    StarActiveIcon,
    StarInactiveIcon,
    EditSurveyIcon,
    RemoveResponseIcon,
    AddIcon,
    ErrorIcon,
    UpArrowIcon
}